const messages = {
  seasons: {
    all: "Sve sezone",
    summer: "Ljeto",
    winter: "Zima",
    general: "Opće",
  },
  offer:
    "Redovito proširujemo naše <br />ponude za vas! <br /><br />Obavijestit ćemo vas o novim tečajevima za obuku u vašoj primljenoj pošti.",
  summary: {
    congratulations: "ČESTITAMO - ZAVRŠILI STE VAŠU EKSPERTIZU O",
    participation:
      "Uspješno ste završili online obuku za Transporter gume za sve sezone.",
    certificate:
      "Vaš certifikat će vam biti poslan email-om ili možete direktno preuzeti kao PDF ovdje:",
    send: "Preuzmite certifikat",
  },
  online: {
    title: "Naši online treningi",
    desc: "Osigurajte ekspertsko znanje i, nakon uspješnog završetka odgovarajućih testova za obuku, vaš<br> osobni certifikat o sudjelovanju kao i 40 dodatnih bodova za premium klub po prvi put",
    content:
      "Otkrijte naše trenutne online treninge sada i sudjelujte odmah na platformi ovdje:",
    categories: {
      title: "Online trening",
      description:
        "Ostanite ispred sa znanjem: Osigurajte ekskluzivnu ekspertizu za vas i vaš tim s našim ponudama obuke. Bilo da su to naše online sesije obuke, kojima možete direktno sudjelovati na platformi, naši tečajevi i praktični seminari u Bridgestone centru za obuku, ili čak vanjski trening čiji troškovi mogu biti smanjeni vašim premium bodovima.",
      general: {
        title: "Opće",
        subtitle: "Online trening: Opće",
        description:
          "Otkrijte najnovije tehnologije, važne razvoje u industriji guma, savjete za vašu prodaju, i još mnogo toga.",
        subdesription:
          "Osigurajte ekspertsko znanje i, nakon uspješnog završetka odgovarajućih testova obuke, vaš osobni certifikat o sudjelovanju kao i jednokratni bonus od 40 dodatnih bodova za premium klub.",
      },
      product: {
        title: "Proizvodi",
        subtitle: "Online trening: Proizvodi",
        description:
          "Produbite vašu Bridgestone i Firestone ekspertizu o proizvodima za uspješnu prodaju s našim kompaktnim video obukama.",
        subdesription:
          "Osigurajte ekspertsko znanje i, nakon uspješnog završetka odgovarajućih testova obuke, vaš osobni certifikat o sudjelovanju kao i jednokratni bonus od 40 dodatnih bodova za premium klub.",
      },
    },
  },
  lectures: {
    title: "Bridgestone treningi",
    desc: "Proširite vašu ekspertizu i rezervirajte naše treninge i intenzivne treninge za vas i vaš tim. Imate opciju da sudjelujete u treningima u Bridgestone centru kompetencija i obuke u Dietzenbachu (blizu Frankfurta na Majni) ili, za odabrane treninge, da se oni provode u vašoj tvrtki. Možete koristiti vaše bonus bodove za treninge i tako pokriti troškove u cijelosti ili djelomično vašim bodovima.",
    content: "Otkrijte naše trenutne treninge sada i zatražite rezervaciju:",
  },
  singleLecture: {
    registerForm: {
      title: "Sadržaj treninga",
      inquiry: "Upit",
      interested: "Zainteresiran sam za trening",
      participantsNr: "Broj sudionika",
      pointsFromBalance: "Želim koristiti bodove iz mog stanja bodova.",
      reduction: "Ovo odgovara smanjenju troškova od {points} eura.",
      request: "Pošaljite upit",
    },
    success: {
      thanks: "Hvala vam",
      title: "Vaš upit je poslan timu za obuku.",
      feedbackTime:
        "Primit ćete odgovor u roku od 14 dana da razjasnimo sve detalje.",
      points:
        "Korišteni bonus bodovi u iznosu od<br /><strong>{points}</strong> bodova su oduzeti s vašeg<br />računa bodova.",
      refund:
        "Ako trening ne bude održan, bodovi će naravno biti vraćeni na vaš račun.",
      queries: "Za pitanja, molimo kontaktirajte:",
    },
    index: {
      costs: "Troškovi i informacije o sudjelovanju",
      duration: "Trajanje: {duration}",
      cost: "Troškovi {cost}: {price} eura",
      participantsNr: "Sudionici: min. {min} - max. {max} ljudi",
    },
  },
  index: {
    title: "Trening i obrazovanje",
    desc: "Prednost kroz znanje: Osigurajte ekskluzivno stručno znanje za vas i vaš tim s našim ponudama obuke. Bilo s našim online treningom, kojem možete direktno sudjelovati na platformi, s našim treningom i praktičnim seminarima u Bridgestone centru za obuku ili s vanjskim treningom, čiji troškovi možete smanjiti vašim nagradnim bodovima.",
    online: {
      title: "Online treningi",
      desc: "Sudjelujte direktno na platformi i osigurajte {points} bodova za premium klub.",
    },
    lectures: {
      title: "Treningi",
      desc: "Visokokvalitetni treningi u našem centru za obuku ili na vašoj lokaciji.",
    },
    external: {
      title: "Vanjski treningi",
      desc: "Koristite bonus bodove za ponude od trećih strana i smanjite troškove.",
    },
  },
  single: {
    done: "Trening zavrsen.",
    doneDownloadCertificate: "Trening zavrsen. Preuzmi certifikat.",
  },
  certificate: {
    header: "CERTIFIKAT",
    atCourse: "je uspješno sudjelovao/la u",
    takePart: "tečaju.",
    contains: "KOMPONENTE TEČAJA",
    country: "Velika Britanija",
  },
};

export default {
  messages,
};
